// Angular
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { AuthService, currentUser, isLoggedIn, Logout } from '../../../../../core/auth';
import { environment } from '@app/../environments/environment';
import { User } from '@app/model/user';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ModalCreateSignInUpComponent } from '@app/views/pages/sign-in-up/modal-create-sign-in-up/modal-create-sign-in-up.component';
import { Router } from '@angular/router';
import { TranslationService } from '../../../../../core/_base/layout';
//import { ConsoleReporter } from 'jasmine';

@Component({
	selector: 'kt-user-profile2',
	templateUrl: './user-profile2.component.html',
})
export class UserProfile2Component implements OnInit {
	// Public properties
	user$: Observable<User>;
	currentUser: any;
	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;
	backend = environment.backendhost;
	isShow: boolean = false;
	currentPermissions: any;
	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(
		private store: Store<AppState>,
		private dialog: MatDialog,
		private toastr: ToastrService,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private authService: AuthService,
		private translationService: TranslationService
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// isLoggedIn — có giá trị ngay khi Login action dispatch
		this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
			if (loggedIn) {
				this.isShow = true;
			} else {
				const token = localStorage.getItem(environment.authTokenKey);
				this.isShow = !!(token && token.length > 10);
			}
			this.cdr.detectChanges();
		});

		this.user$ = this.store.pipe(select(currentUser));
		this.user$.subscribe(res => {
			if (res) {
				this.currentUser = res;
				this.isShow = true;
				this.cdr.detectChanges();
			}
		});
		this.getMyPermissions();
	}

	/**
	 * Log out
	 */
	logout() {
		this.store.dispatch(new Logout());
	}
	//signIn/Up
	openModalSignInUp(type) {
		const dialogRef = this.dialog.open(ModalCreateSignInUpComponent, {
			width: '900px',
			data: { type: type, returnUrl: location.pathname }
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result != undefined) {
				if (result.event) {
					if (result.type == "signin") {
						//this.toastr.success('Đăng nhập thành công');
					}
					else if (result.type == "signup") {
						//this.toastr.success('Đăng kí thành công');
					} else {
						this.toastr.success('Thực hiện thao tác thành công');
					}
				}
			}
		});
	}
	getMyPermissions() {
		this.authService.getMyPermissions().subscribe((res) => {
			this.currentPermissions = res;
			this.cdr.markForCheck();
		});
	}

	// Check if user has admin role
	isAdminUser(user: User | null | undefined): boolean {
		if (!user || !user.roles || !Array.isArray(user.roles)) {
			return false;
		}
		const adminRoles = ['Admin', 'Content Admin', 'Salesman'];
		return user.roles.some((role: string) => adminRoles.includes(role));
	}
	//end signIn/Up
}
